// extracted by mini-css-extract-plugin
export var audioPlayer = "_t2-0";